export default function Trash() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
            <path d="M7.5 3.41699H12.5" stroke="#919191" strokeWidth="1.33333" strokeLinecap="round" />
            <path d="M2.91797 5.91699H17.0846" stroke="#919191" strokeWidth="1.33333" strokeLinecap="round" />
            <path
                d="M5 8.83301V16.6455C5 17.1633 5.41973 17.583 5.9375 17.583H14.0625C14.5803 17.583 15 17.1633 15 16.6455V8.83301"
                stroke="#919191"
                strokeWidth="1.33333"
                strokeLinecap="round"
            />
            <path d="M8.33203 8.83301V14.2497" stroke="#919191" strokeWidth="1.33333" strokeLinecap="round" />
            <path d="M11.668 8.83301V14.2497" stroke="#919191" strokeWidth="1.33333" strokeLinecap="round" />
        </svg>
    );
}
